import type { ComboboxItem} from '@mantine/core';
import {Alert} from 'src/design/atoms/Alert';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {Title} from 'src/design/atoms/Title';
import React from 'react';
import type {
  NotificationRuleMetadata} from 'src/api/ProactApiClient';
import {
  NotificationRuleTypeEnum,
} from 'src/api/ProactApiClient';
import {EditNotificationChangeEventRules} from './EditNotificationChangeEventRules';
import {EditNotificationReminderRules} from './EditNotificationReminderRules';

export interface EditNotificationRulesProps {
  ruleType: NotificationRuleTypeEnum;
  data: NotificationRuleMetadata;
  onDataChange(data: NotificationRuleMetadata): void;
  disabled: boolean;
  validationError?: string;
  onConditionsChange?: () => void;
  attachmentClassificationOptions?: ComboboxItem[];
  attachmentTypeOptions?: ComboboxItem[];
}
export const EditNotificationRules: React.FC<EditNotificationRulesProps> = ({
  ruleType,
  data,
  onDataChange,
  disabled,
  validationError,
  onConditionsChange,
  attachmentClassificationOptions,
  attachmentTypeOptions,
}) => {
  // Wrap onDataChange to call onConditionsChange when conditions are modified
  const handleDataChange = (newData: NotificationRuleMetadata): void => {
    onConditionsChange?.();
    onDataChange(newData);
  };
  return (
    <Stack gap="xs">
      <Title order={4}>Conditions</Title>
      <Text size="sm" c="dimmed">
        Define when this notification triggers. All conditions must be met for
        the notification to send.
      </Text>

      {validationError && (
        <Alert color="red" title="Validation Error">
          {validationError}
        </Alert>
      )}

      {Number(ruleType) === NotificationRuleTypeEnum.Reminder && (
        <EditNotificationReminderRules
          data={data}
          onDataChange={handleDataChange}
          disabled={disabled}
          classificationOptions={attachmentClassificationOptions}
          attachmentTypeOptions={attachmentTypeOptions}
        />
      )}
      {Number(ruleType) === NotificationRuleTypeEnum.ChangeEvent && (
        <EditNotificationChangeEventRules
          data={data}
          onDataChange={handleDataChange}
          disabled={disabled}
          attachmentClassificationOptions={attachmentClassificationOptions}
          attachmentTypeOptions={attachmentTypeOptions}
        />
      )}
    </Stack>
  );
};
